import axios from 'axios'
import router from '@/router'
import store from '@/store'

export default {

  async register(model) {
    try {
      let resp = await axios.post('/api/auth/register', model)
      this.setTokens(resp.data)
      store.commit('LOGIN_USER', resp.data.user)
      router.push({
        name: 'Dashboard'
      })
    } catch (error) {
      if (error.data && error.data.general) {

      }
      console.log(error)
    }
  },

  async login(model, callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost
    try {
      model.env = 'DPS'
      let respToken = await axios.post(`${apiUrl}/api/login`, model)
      store.commit('UPDATE_TOKEN', respToken.data)
      let respUser = await axios.get(`${apiUrl}/dps/manager/profile`)
      store.commit('LOGIN_USER', respUser.data)
      callback()
    } catch (error) {
      console.log(error)
      errorCallback()
    }
  },

  async logout() {
    // Clear access token and ID token from local storage
    try {
      store.commit('LOGOUT_USER')
      router.push({
        name: 'Login'
      })
    } catch (error) {
      console.log(error)
    }
  },

  async requestResetPassword(params, callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost
    try {
      let resp = await axios.get(`${apiUrl}/dps/password/forgot`, {
        params: params
      });
      if (resp.status === 200) {
        callback(resp.data)
      } else {
        errorCallback(resp.data)
      }
    } catch (error) {
      console.log(error)
      errorCallback()
    }
  },

  async resetPassword(url, params, callback, errorCallback) {
    let apiUrl = url
    try {
      let resp = await axios.post(`${apiUrl}/dps/password/modify`, params);
      if (resp.status === 200) {
        callback(resp.data)
      } else {
        errorCallback(resp.data)
      }
    } catch (error) {
      errorCallback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/authService.js